import React from 'react';
import PropTypes from 'prop-types';

import styles from './index.module.css';

function IconButton(props) {
  return (
    <button
      disabled={props.disabled}
      className={`${styles.button} ${
        styles['icon-' + props.icon]
      } ${props.className || ''}`}
      onClick={props.onClick}
    />
  );
}

IconButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default IconButton;
